module.exports = __webpack_public_path__ + "img/blockquote.1b118f5a.webp";